module.exports = __webpack_public_path__ + "static/assets/e6a07a5b0c214c0545a02d4b42269378.png";